<template>
  <div class="detail-content-tabs">
    <ul :style="contentTabFixed ? 'position:fixed;top:0;z-index:1;' : ''">
      <li
        v-for="(tab, index) in tabInfo"
        :key="tab.id"
        :class="{ 'tab--active': tab.show }"
        @click="changeTab(tab, index, $event)"
      >
        <span>{{ tab.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'detail-content-tabs',
  props: ['contentTabFixed', 'tabInfo', 'courseDetail'],
  data() {
    return {}
  },
  methods: {
    changeTab({ id, top }, index, event) {
      this.$emit('clickPoint', index)
      window.scrollTo({
        top: top + 130
      })
      const clickId = {
        courseRecommend: '1.3.24',
        courseParticulars: '1.3.25',
        courseOutline: '1.3.26',
        courseComment: '1.3.27'
      }
      const params = {
        key: `xeslog-${id}-courseDetail`,
        clickId: clickId[id],
        counselorid: this.courseDetail.classLeftNumModule.classId || '',
        exclusiveid: this.courseDetail.classLeftNumModule.classId || '',
        timeid: this.courseDetail.courseInfoModule.schoolTimeName,
        difficultid: this.courseDetail.courseInfoModule.difficulty.alias
      }
      // this.xesLog('click', params, event)
      this.$xesLogger.clickMsg({params: { params }})
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(detail-content-tabs) {
  height: 60px;
  background-color: #fafafa;
  & > ul {
    width: 828px;
    background: #fafafa;
    height: 60px;
    margin: 0;
    padding: 0;
    & > li {
      display: inline-block;
      box-sizing: border-box;
      border-top: 2px solid #fafafa;
      width: 160px;
      line-height: 58px;
      font-size: 16px;
      text-align: center;
      position: relative;
      color: #666666;
      cursor: pointer;
    }
  }
}
@include b(tab) {
  @include m(active) {
    border-top: 2px solid #f13232 !important;
    background-color: #ffffff;
    span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #333333;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DetailContent.vue